var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',_vm._b({ref:"IonForm",staticClass:"ion-form",attrs:{"model":_vm.model},on:{"validate":_vm.checkField}},'el-form',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }